










































































































































import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import { currencyFormat } from '@/utils/helpers';
import { IAutocreditLedger, PayloadState } from '@/types/types';

@Component({
  name: 'AutocreditResolveDialog',
  filters: { currencyFormat },
})
export default class AutocreditResolveDialog extends Vue {
  @Prop({ required: true, default: false }) state!: boolean;
  @Prop({ default: false }) loading!: boolean;
  @Prop({ default: null }) ledger!: IAutocreditLedger | null;

  action: 'retry' | 'new-reference' | 'mark-posted' = 'retry';
  reason: string = '';
  downstreamReference: string = '';
  confirmedNotPaid: boolean = false;

  get isDuplicateReference(): boolean {
    return /already exist|duplicate/i.test(this.ledger?.lastError ?? '');
  }

  get canSubmit(): boolean {
    if (this.action === 'mark-posted') return !!this.downstreamReference && !!this.reason;
    if (this.action === 'new-reference' && this.isDuplicateReference) return this.confirmedNotPaid;
    return true;
  }

  @Watch('state')
  onStateChange(open: boolean): void {
    if (!open) return;
    // Default to the safe action when the provider says it already has this reference.
    this.action = this.isDuplicateReference ? 'mark-posted' : 'retry';
    this.reason = '';
    this.downstreamReference = '';
    this.confirmedNotPaid = false;
  }

  @Emit('actions')
  close(payload: PayloadState) {
    return payload;
  }

  @Emit('resolve')
  submit() {
    return {
      action: this.action,
      ledgerId: this.ledger?._id,
      reason: this.reason || undefined,
      downstreamReference: this.downstreamReference || undefined,
      confirmedNotPaid: this.confirmedNotPaid || undefined,
    };
  }
}
